export enum SignatureStatus {
  CREATED = 'CREATED',

  VIEWED = 'VIEWED',

  SIGNED = 'SIGNED',

  REJECTED = 'REJECTED',

  EXPIRED = 'EXPIRED',
}
